var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 166,
    viewBox: "0 0 158 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.4729 116.218L60.2757 165.59L0 84.1875L97.4729 116.218Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4729 116.218L60.2757 165.59L0 84.1875L97.4729 116.218Z",
    fill: "url(#paint0_linear_1177_287)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3719 0L60.8311 104.182L0 84.1871L61.3719 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3719 0L60.8311 104.182L0 84.1871L61.3719 0Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3719 0L60.8311 104.182L0 84.1871L61.3719 0Z",
    fill: "url(#paint1_linear_1177_287)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.627 31.636L61.0312 65.932L61.3747 0L157.627 31.636Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.627 31.636L61.0312 65.932L61.3747 0L157.627 31.636Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.623 31.636L61.0273 65.932L61.3708 0L157.623 31.636Z",
    fill: "url(#paint2_linear_1177_287)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.627 135.993L97.4609 52.9968L157.627 31.6357V135.993Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.627 135.993L97.4609 52.9968L157.627 31.6357V135.993Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.627 135.993L97.4609 52.9968L157.627 31.6357V135.993Z",
    fill: "url(#paint3_linear_1177_287)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1177_287",
    x1: 74.8835,
    y1: 189.897,
    x2: 30.5216,
    y2: 72.5233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1177_287",
    x1: 47.1489,
    y1: 135.29,
    x2: -35.7906,
    y2: 27.3318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1177_287",
    x1: 135.237,
    y1: 85.6193,
    x2: 104.599,
    y2: -13.5635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1177_287",
    x1: 143.683,
    y1: 167.154,
    x2: 60.1604,
    y2: 60.7508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject4);
export default __webpack_public_path__ + "static/media/project4.7a6879e2b4b7330a88a66c901cf56365.svg";
export { ForwardRef as ReactComponent };